import { images, type ImageName } from '../generated/images'

export type ImageFormat = 'avif' | 'webp'

/** URL of one generated derivative (scripts/optimize-images.py); widest by default. */
export function imageUrl(name: ImageName, format: ImageFormat = 'webp', width?: number): string {
  const { widths, hash } = images[name]
  const w = width ?? widths[widths.length - 1]
  return `/img/${name}-${w}.${hash}.${format}`
}

/** `srcset` with width descriptors for every generated size. */
export function imageSrcSet(name: ImageName, format: ImageFormat): string {
  return images[name].widths.map((w) => `${imageUrl(name, format, w)} ${w}w`).join(', ')
}

/** Reverse of imageUrl: the image name, or null if the URL isn't one of ours. */
export function imageNameFromUrl(url: string | null | undefined): ImageName | null {
  const name = url?.match(/^\/img\/(.+)-\d+\.[0-9a-f]{8}\.(?:webp|avif)$/)?.[1]
  return name && name in images ? (name as ImageName) : null
}
